'use strict';

import Modal from 'react-modal';
import React, { Component } from 'react';
import DistribucionLimitesCuentaContainer from '../../DistribucionLimitesCuenta/components/Container.jsx';
import DistribucionLimitesEmpresaContainer from '../../DistribucionLimitesEmpresa/components/Container.jsx';
import DistribucionLimitesTarjetaContainer from '../../DistribucionLimitesTarjeta/components/Container.jsx';
import BotonesGuardado from './BotonesGuardado.jsx';
import PrincipalHeader from './PrincipalHeader.jsx';
import { GenericOption, GenericSelect, GenericModal, GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

import GlobalHelper from '../../../Common/Helpers/GlobalHelper.js';

class DistribucionLimites extends Component {
    constructor(props) {
        super(props);
        this.state = { childComponentEditing: false };
        this.toggleEditFn = this.toggleChildComponentEditing.bind(this);
    }

    componentDidMount() {
        this.props.getScreenData(this.props.currentScope, this.props.datosCliente, this.props.tarjetas, this.props.getDatosFromDB, this.props.sesion);
    }

    /**
     * 
     */
    toggleChildComponentEditing() {
        this.setState({ childComponentEditing: !this.state.childComponentEditing });
    }

    /**
     * 
     */
    aceptModalPrincipal() {
        $('#okModalPrincipal').modal('toggle');
    }

    render() {
        const { data, datosCliente } = this.props;
        const limitesCliente = GlobalHelper.ObtenerLimitesEmpresaCliente(data.empresas, data.novedadesEmpresas, datosCliente);

        /*si data no tiene nada, entonces mando un null, no hay nada que renderizar*/
        if (!data)
            return null;

        let body = undefined;

        if (this.props.data.selectLimit !== undefined) {
            switch (this.props.data.selectLimit) {
                case 0:
                    body = <DistribucionLimitesEmpresaContainer
                        limitesCliente={limitesCliente}
                        data={this.props.data}
                        cambiarEstadoEdicion={this.props.cambiarEstadoEdicionEmpresa} />
                    break;
                case 1:
                    body = <DistribucionLimitesCuentaContainer
                        limitesCliente={limitesCliente}
                        data={this.props.data}
                        cambiarEstadoEdicion={this.props.cambiarEstadoEdicionCuenta}
                        obtenerLimiteCuentaPorProducto={this.props.obtenerLimiteCuentaPorProducto}/>
                    break;
                case 2:
                    body = <DistribucionLimitesTarjetaContainer
                        limitesCliente={limitesCliente}
                        data={this.props.data}
                        cambiarEstadoEdicion={this.props.cambiarEstadoEdicionTarjeta} />
                    break;
                default:
                    body = null;
                    break;
            }
        }
        
        <Modal isOpen={this.props.data.abrirModalEstaEditando} contentLabel="Modal">
            <label>No se puede salir en el medio de una edición</label>
            <GenericSimpleButton text="Ok" buttonClass="btn btn-secondary" onClick={() => this.props.closeModalEstaEditando()} />
        </Modal >;
        
        return (
            <div className="container-fluid">
                <PrincipalHeader
                    data={this.props.data}
                    isEditingData={this.state.childComponentEditing}
                    changeLimite={this.props.changeLimite} />

                {body}

                <BotonesGuardado
                    guardar={this.props.guardar}
                    guardaDatos={this.props.guardaDatos}
                    cancelar={this.props.cancelar}
                    cerrarModal={this.props.cerrarModal}
                    abrirModalEstaEditando={this.props.data.abrirModalEstaEditando}
                    data={this.props.data}
                    actualizarEstadoPantallaInvocadora={this.props.actualizarEstadoPantallaInvocadora}
                />
                <GenericModal type={"OK_OTHER"} className="modal fade-out" id={"okModalPrincipal"} onClick={this.aceptModalPrincipal} header={"Advertencia"}
                    body={"Se deben confirmar o descartar los cambios de límite que se iniciaron en la grilla"} />
            </div>
        );
    }
}

export default DistribucionLimites;